import { useState, useEffect } from 'react';
import { _AgreementClassification } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../core/services/dataBean/useDataBean';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const AgreementSelect = ({ idSelector, onChange, label }: Props) => {

    const agreement = useDataBean(_AgreementClassification)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }



    const getLista = () => {

        agreement.instance.getAgreementClassificationCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }

    return (
        <>
            <label>{label ?? "Clasificacion de Convenio:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDAgreementClassification} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}